// 用于存储组件相关的数据

const state = {
  imageUpload: null, // 图片上传相关参数
}
const getters = {
  imageUpload: (state) => state.imageUpload,
}
const mutations = {
  IMAGE_UPLOAD(state, imageUpload) {
    state.imageUpload = imageUpload
  },
}
const actions = {
  // 设置图片上传缓存
  setImageUploadCache({ commit, getters }, options) {
    let imageUpload = getters.imageUpload || {}
    for (let key in options) {
      imageUpload[key] = options[key]
    }
    commit('IMAGE_UPLOAD', imageUpload)
  },
  // 清除缓存
  clearCache({ commit }, key) {
    commit(key, null)
  },
}
export default { state, getters, mutations, actions }
